import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { OwnerInterface } from '@app/interfaces/owner.interface';
import { Subject } from 'rxjs';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ContactSpecialistComponent } from '@app/components/contact-specialist/contact-specialist.component';
import { MatButtonModule } from '@angular/material/button';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { MortgagesService } from '@app/services/mortgages.service';

@Component({
    selector: 'app-documents-confirm-dialog',
    templateUrl: './documents-confirm-dialog.component.html',
    styleUrls: ['./documents-confirm-dialog.component.scss'],
    imports: [MatIconModule, MatDialogModule, ContactSpecialistComponent, MatButtonModule],
})
export class DocumentsConfirmDialogComponent implements OnInit, OnDestroy {
    protected readonly mortgagesService = inject(MortgagesService);
    matDialogRef = inject<MatDialogRef<DocumentsConfirmDialogComponent>>(MatDialogRef);

    public mortgage: MortgageInterface;
    public owner: OwnerInterface;
    public ownerPhoneLink: string;

    protected destroyed$: Subject<void> = new Subject<void>();

    public ngOnInit() {
        this.mortgagesService.mortgage$.pipe(takeUntil(this.destroyed$)).subscribe((mortgage: MortgageInterface) => {
            if (mortgage) {
                this.mortgage = mortgage;
                this.owner = this.mortgage?._owner;
                this.ownerPhoneLink = this.owner?.phone?.replace(/ /g, '');
            }
        });
    }

    ngOnDestroy(): void {
        this.destroyed$?.next();
        this.destroyed$?.complete();
    }
}
